import axios from "axios"
import store from "../store"
import getEnv from "../utils/env"

const api = axios.create({
	"baseURL": getEnv("VUE_APP_API_BASE_URL") || "/api/v1",
	headers: {
		Accept: "application/json",
		"Content-Type": "application/json",
		Authorization: store.getters["user/getToken"]
	}
})

api.interceptors.request.use(function (config) {
	const token = store.getters["user/getToken"]
	config.headers.Authorization = token

	return config
})

api.interceptors.response.use(function (response) {
	return Promise.resolve(response)
}, async function (err) {
	if (!err.response) {
		//store.dispatch('user/logout', {root: true})
		//router.push('/login')
		throw (err.message || err)
	} else if (err.response.status === 401 && err.config && !err.config.nointercept && !err.config.refreshTokenRequest) {
		let config = err.config
		await store.dispatch("user/refreshToken", {root: true})
		return api(config)
	} else if (err.config.refreshTokenRequest) {
		store.dispatch("loading/RESET_ERROR", {root:true})
		store.dispatch("user/logout", {root: true})
		throw ("Could not authenticate!")
	} else {
		console.error(err)
		return Promise.reject(err)
	}
})

export default api